exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Ro1z5_2X1U13K{position:relative}", ""]);

// exports
exports.locals = {
	"wrapper": "_1Ro1z5_2X1U13K"
};